import type { TypedUseSelectorHook } from "react-redux";
import { useDispatch, useSelector } from "react-redux";
import type { AppDispatch, RootState } from "src/store/store";

// 사용자의 action, hook, dispather을 정리
// hook은 클래스형의 라이프사이클을 의미 (componentDidMount)

export const useChange = (value: any, func: any) => {
  func(value);
};

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
